import { http } from "../http";

export type UserRole = AdminUser["role"];

/**
 * Speglar MANAGEABLE_ROLES i api/adminRoutes.js. Servern avgör ändå, det här
 * styr bara vilka knappar och val som visas.
 */
export const MANAGEABLE_ROLES: Partial<Record<UserRole, UserRole[]>> = {
  SUPERADMIN: ["ADMIN", "CONTRIBUTOR", "USER"],
  ADMIN: ["CONTRIBUTOR", "USER"],
};

export function canManageRole(actor: UserRole | null | undefined, target: UserRole) {
  return !!actor && (MANAGEABLE_ROLES[actor] ?? []).includes(target);
}

export type CreateUserInput = {
  email: string;
  password: string;
  firstName?: string;
  lastName?: string;
  yearOfBirth: number;
  role: UserRole;
};

export async function createUser(body: CreateUserInput) {
  return http.post<{ ok: boolean; user: AdminUser }>("/admin/users", body);
}

export async function deleteUser(userId: string) {
  return http.delete<{ ok: boolean; id: string }>(`/admin/users/${encodeURIComponent(userId)}`);
}

export type BlockUserInput = { userId: string; reason?: string };

export type AdminUser = {
    id: string;
    email: string;
    role: "USER" | "CONTRIBUTOR" | "ADMIN" | "SUPERADMIN";
    blocked: boolean;
    createdAt?: string;
    firstName?: string;
    lastName?: string;
  };
  

export async function blockUser({ userId, reason }: BlockUserInput) {
  return http.post(`/admin/users/${encodeURIComponent(userId)}/block`, { reason });
}

export async function unblockUser(userId: string) {
  return http.post(`/admin/users/${encodeURIComponent(userId)}/unblock`, {});
}

export async function listUsers(params?: { q?: string; page?: number }) {
  const qs = new URLSearchParams();
  if (params?.q) qs.set("q", params.q);
  if (params?.page) qs.set("page", String(params.page));
  const suffix = qs.toString() ? `?${qs.toString()}` : "";
  return http.get<AdminUser[]>(`/admin/users${suffix}`);
}
